module.exports = __webpack_public_path__ + "img/geschmiedetestor.3232ceab.webp";